import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { translations } from '@/i18n/translations';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'cea-lang';

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored && translations[stored]) return stored;
      }
    } catch (e) {
      // localStorage may be unavailable (private mode, blocked cookies, sandboxed iframes)
      console.warn('No s\'ha pogut llegir la preferència d\'idioma des de localStorage:', e);
    }
    return 'ca';
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) {
      console.warn('No s\'ha pogut desar la preferència d\'idioma a localStorage:', e);
    }
  }, []);

  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
};
